import React, { useState } from "react";
//import "./ModalStyles.css";

const MarkDoneModal = ({ isOpen, onClose, onSave }) => {
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!comment.trim()) {
      setError("Comment is required");
      return;
    }
    setError("");
    onSave(comment);
    setComment("");
    onClose();
  };

  const handleCancel = () => {
    setComment("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h5>Mark Meeting as Done</h5>
        <input
          className="form-control my-2"
          placeholder="Enter comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        {error && <p className="text-danger tx-12">{error}</p>}
        <div className="d-flex justify-content-end gap-2 mt-2">
          <button className="btn btn-sm btn-danger" onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn btn-sm btn-success" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarkDoneModal;
